var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.toggleDisplay)?_c('div',{staticClass:"form-search-wrapper"},[(_vm.title)?_c('div',{staticClass:"form-search-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{directives:[{name:"enter-search",rawName:"v-enter-search",value:(_vm.onEnterSearch),expression:"onEnterSearch"}],staticClass:"form-search"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }